module.exports = __webpack_public_path__ + "static/media/1016270.170eb792.png";